module.exports = __webpack_public_path__ + "img/conference.b86180b9.jpg";